import { applicantStatusTypes } from '../constants/statusConstants';
import _ from 'lodash';

export function getApplicants(data) {
  return _.get(data, `property.application.applicants`, []);
}
export function getIsPendingApplicant(applicant) {
  return applicant.status !== applicantStatusTypes.COMPLETED.id;
}

export function getHasPendingApplicants(applicants) {
  return applicants.some(getIsPendingApplicant);
}

export function getAllApplicantIds(applicants) {
  return applicants.map((applicant) => applicant.id);
}

export function getPrimaryApplicant(applicants) {
  return applicants.find((applicant) => applicant.isPrimaryApplicant) || applicants[0];
}

export function getHasPrimaryApplicantOnly(applicants) {
  return Boolean(getPrimaryApplicant(applicants)) && applicants.length === 1;
}

export function filterVouchersFromApplicants(applicants, onlyDisplayVouchers) {
  return applicants.map((applicant) => ({
    ...applicant,
    currentIncomes: applicant?.answers?.currentIncomes?.filter((currentIncome) =>
      onlyDisplayVouchers ? currentIncome.type === 'voucher' : currentIncome.type !== 'voucher',
    ),
  }));
}
